import React from "react";
import style from "../sass/skill.module.scss";
import { ReactComponent as Bootstrap5 } from "../helper/svgicon/skills/Bootstrap5.svg";
import { ReactComponent as C } from "../helper/svgicon/skills/C.svg";
import { ReactComponent as Chakra } from "../helper/svgicon/skills/Chakra.svg";
import { ReactComponent as Cplus } from "../helper/svgicon/skills/Cplus.svg";
import { ReactComponent as Css3 } from "../helper/svgicon/skills/Css3.svg";
import { ReactComponent as Express } from "../helper/svgicon/skills/Express.svg";
import { ReactComponent as Git } from "../helper/svgicon/skills/Git.svg";
import { ReactComponent as Html } from "../helper/svgicon/skills/Html.svg";
import { ReactComponent as Javascript } from "../helper/svgicon/skills/Javascript.svg";
import { ReactComponent as Json } from "../helper/svgicon/skills/Json.svg";
import { ReactComponent as Jwt } from "../helper/svgicon/skills/Jwt.svg";
import { ReactComponent as Linux } from "../helper/svgicon/skills/Linux.svg";
import { ReactComponent as Material } from "../helper/svgicon/skills/Material.svg";
import { ReactComponent as Mongodb } from "../helper/svgicon/skills/Mongodb.svg";
import { ReactComponent as Mongoose } from "../helper/svgicon/skills/Mongoose.svg";
import { ReactComponent as Nodejs } from "../helper/svgicon/skills/Nodejs.svg";
import { ReactComponent as Postman } from "../helper/svgicon/skills/Postman.svg";
import { ReactComponent as Prettier } from "../helper/svgicon/skills/Prettier.svg";
import { ReactComponent as Python } from "../helper/svgicon/skills/Python.svg";
import { ReactComponent as Reactjs } from "../helper/svgicon/skills/React.svg";
import { ReactComponent as Redux } from "../helper/svgicon/skills/Redux.svg";
import { ReactComponent as Sass } from "../helper/svgicon/skills/Sass.svg";
import { ReactComponent as Vscode } from "../helper/svgicon/skills/Vscode.svg";
export const AllSkillIcons = () => {
     return (
          <>
               <div className={style.skill_list_icons}>
                    <C />
                    <p>C</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Cplus />
                    <p>C++</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Javascript />
                    <p>Javascript</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Python />
                    <p>Python</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Html />
                    <p>Html</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Css3 />
                    <p>Css3</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Sass />
                    <p>Sass</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Bootstrap5 />
                    <p>Bootstrap5</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Material />
                    <p>MaterialUI</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Chakra />
                    <p>ChakraUI</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Json />
                    <p>Json</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Reactjs />
                    <p>React</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Redux />
                    <p>Redux</p>
               </div>

               {/* Backend */}
               <div className={style.skill_list_icons}>
                    <Nodejs />
                    <p>Nodejs</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Express />
                    <p>Express</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Mongodb />
                    <p>Mongodb</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Mongoose />
                    <p>Mongoose</p>
               </div>

               {/* Tools */}
               <div className={style.skill_list_icons}>
                    <Linux />
                    <p>Linux</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Vscode />
                    <p>Vscode</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Prettier />
                    <p>Prettier</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Git />
                    <p>Git</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Postman />
                    <p>Postman</p>
               </div>
          </>
     );
};
// export default AllSkillIcons;

export const LanguageSkillIcons = () => {
     return (
          <>
               <div className={style.skill_list_icons}>
                    <C />
                    <p>C</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Cplus />
                    <p>C++</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Javascript />
                    <p>Javascript</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Python />
                    <p>Python</p>
               </div>
          </>
     );
};

export const FrontendSkillIcons = () => {
     return (
          <>
               <div className={style.skill_list_icons}>
                    <Html />
                    <p>Html</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Css3 />
                    <p>Css3</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Sass />
                    <p>Sass</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Bootstrap5 />
                    <p>Bootstrap5</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Material />
                    <p>MaterialUI</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Chakra />
                    <p>ChakraUI</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Json />
                    <p>Json</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Reactjs />
                    <p>React</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Redux />
                    <p>Redux</p>
               </div>
          </>
     );
};

export const BackendSkillIcons = () => {
     return (
          <>
               <div className={style.skill_list_icons}>
                    <Nodejs />
                    <p>Nodejs</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Express />
                    <p>Express</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Mongodb />
                    <p>Mongodb</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Mongoose />
                    <p>Mongoose</p>
               </div>
          </>
     );
};

export const ToolsSkillIcons = () => {
     return (
          <>
               <div className={style.skill_list_icons}>
                    <Linux />
                    <p>Linux</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Vscode />
                    <p>Vscode</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Prettier />
                    <p>Prettier</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Git />
                    <p>Git</p>
               </div>
               <div className={style.skill_list_icons}>
                    <Postman />
                    <p>Postman</p>
               </div>
          </>
     );
};
